export function buildPurchaseEditState(row, selectedSite) {
  return {
    purchaseNo: row?.purchaseNo || row?.purchaseNumber || row?.purchase_no || "",
    purchaseDate: row?.purchaseDate || row?.date || "",
    partyName: row?.partyName || "",
    receiverName: row?.receiverName || "",
    paymentStatus: row?.paymentStatus || "UNPAID",
    description: row?.description || "",
    site: row?.site || selectedSite || null,
    purchaseItems: Array.isArray(row?.purchaseItems) && row.purchaseItems.length > 0
      ? row.purchaseItems.map(item => ({
          materialName: item?.materialName || "",
          unit: item?.unit || "",
          quantity: item?.quantity ?? "",
          rate: item?.rate ?? "",
          amount: item?.amount ?? "",
          remarks: item?.remarks || "",
        }))
      : [{ materialName: "", unit: "", quantity: "", rate: "", amount: "", remarks: "" }],
    invoiceFile: null,
  };
}

export function buildSellEditState(row, selectedSite) {
  return {
    id: row?.id ?? row?.sellId ?? row?.sell_id ?? null,
    sellId: row?.sellId ?? row?.sell_id ?? row?.id ?? null,
    sell_id: row?.sell_id ?? row?.sellId ?? row?.id ?? null,
    sellNo: row?.sellNo || row?.sell_no || row?.saleNo || row?.billNo || "",
    billType: row?.billType || row?.bill_type || "",
    sellDate: row?.sellDate || row?.date || "",
    paymentStatus: row?.paymentStatus || row?.payment_status || "UNPAID",
    site: row?.site || selectedSite || null,
    sellItems: Array.isArray(row?.sellItems) && row.sellItems.length > 0
      ? row.sellItems.map(item => ({
          materialName: item?.materialName || "",
          unit: item?.unit || "",
          quantity: item?.quantity ?? "",
          rate: item?.rate ?? "",
          amount: item?.amount ?? "",
          remarks: item?.remarks || "",
        }))
      : [{ materialName: "", unit: "", quantity: "", rate: "", amount: "", remarks: "" }],
    invoiceFile: null,
  };
}

export function buildExpenseEditState(row) {
  return {
    id: row?.id ?? row?.expenseId ?? row?.expense_id ?? null,
    expenseId: row?.expenseId ?? row?.expense_id ?? row?.id ?? null,
    expense_id: row?.expense_id ?? row?.expenseId ?? row?.id ?? null,
    expenseType: row?.expenseType || row?.category || "",
    expenseDate: row?.expenseDate || row?.date || "",
    amount: row?.amount ?? "",
    remark: row?.remark || row?.remarks || "",
    spentBy: row?.spentBy || row?.spent_by || "",
    attachmentFile: null,
  };
}

export function buildContractorWorkEditState(row, selectedSite) {
  return {
    id: row?.id ?? row?.contractorWorkId ?? row?.workId ?? null,
    contractorId: row?.contractorId ?? row?.contractorObject?.id ?? row?.contractor?.id ?? null,
    contractorName: row?.contractorName || row?.contractorObject?.contractorName || row?.contractorObject?.name || row?.contractor?.contractorName || row?.contractor?.name || "",
    contractorObject: row?.contractorObject || row?.contractor || null,
    mobile: row?.mobile || row?.mobileNumber || row?.contractorObject?.mobile || "",
    workDate: row?.workDate || "",
    numberOfLabours: row?.numberOfLabours ?? row?.labourCount ?? "",
    labourRate: row?.labourRate ?? "",
    numberOfMasons: row?.numberOfMasons ?? "",
    masonRate: row?.masonRate ?? "",
    labourAmount: row?.labourAmount ?? "",
    masonAmount: row?.masonAmount ?? "",
    otherCharges: row?.otherCharges ?? "",
    description: row?.description || "",
    site: row?.site || selectedSite || null,
    siteId: (row?.siteId ?? row?.site?.id ?? selectedSite?.id) || "",
  };
}

export const normalizeContractorPaymentMethod = (value) => {
  if (value === undefined || value === null) {
    return "CASH";
  }
  const normalized = String(value).trim().toUpperCase().replace(/\s+/g, "_");
  return ["CHEQUE", "CASH", "BANK_TRANSFER", "UPI"].includes(normalized) ? normalized : "CASH";
};

export function buildContractorPaymentEditState(row, selectedSite) {
  return {
    id: row?.id ?? row?.contractorPaymentId ?? row?.paymentId ?? null,
    contractorId: row?.contractorId ?? row?.contractorObject?.id ?? row?.contractor?.id ?? null,
    contractorName: row?.contractorName || row?.contractorObject?.contractorName || row?.contractorObject?.name || row?.contractor?.contractorName || row?.contractor?.name || "",
    contractorObject: row?.contractorObject || row?.contractor || null,
    paymentDate: row?.paymentDate || "",
    amount: row?.amount ?? row?.paymentAmount ?? "",
    paymentMethod: normalizeContractorPaymentMethod(row?.paymentMethod),
    description: row?.description || row?.remarks || row?.remark || "",
    site: row?.site || selectedSite || null,
    siteId: (row?.siteId ?? row?.site?.id ?? selectedSite?.id) || "",
  };
}

export function buildFuelPumpEditState(row, selectedSite) {
  return {
    id: row?.id ?? row?.fuelPumpId ?? row?.fuel_pump_id ?? null,
    fuelType: row?.fuelType || row?.fuel_type || "",
    vehicleNumber: row?.vehicleNumber || row?.vehicle_number || "",
    amount: row?.amount ?? "",
    quantity: row?.quantity ?? "",
    receivedBy: row?.receivedBy || row?.received_by || "",
    approvedBy: row?.approvedBy || row?.approved_by || "",
    fuelDate: row?.fuelDate || row?.date || row?.fuel_date || "",
    site: row?.site || selectedSite || null,
    siteId: (row?.siteId ?? row?.site?.id ?? selectedSite?.id) || "",
  };
}
